import { useEffect, useContext } from "react";
import { useStore } from "../../TEMPLATE/hooks/store";
import { getAllSensors, getAllTypes } from "../../TEMPLATE/services/feed";
import {
  feedBins,
  feedEnvironment_Meteo,
  feedFleeto,
  feedHydro,
  feedMeshlium,
  feedParking,
  feedWifi,
} from "../../TEMPLATE/services/metrics";
import {
  allTypesUrl,
  allSensorsUrl,
  meteoURL,
  fleetoUrl,
  binsUrl,
  wifiUrl,
  enviURL,
  hydroUrl,
  parkingUrl,
} from "../hardCodeData/DATA";
import PARKING_DATA from "../hardCodeData/parknigData.json"
import LanguageContext from "./../../TEMPLATE/hooks/language-context";


// hotspot hardcoded data, not recomended
const wifiHotspotSensors = {
  id: "487",
  title: 'Wifi Hotspot Πεζόδρομος Άλεξ. Ρώμα',
  position: {lat: 37.7849615, lng: 20.89703},
  address:null,
  boxTitle:"Wifi Hotspots",
  color:"#FF006E",
  description:null,
  group:undefined,
  groupName:undefined,
  isActive:false,
  locationId:null,
  smallMarker:"https://zakynthos.smartiscity.gr/gallery/mapicons/pin-blue.png",
  tooltip:"Δείτε απευθείας τα σημεία wifi hotspot της περιοχής",
  typeId:"4",
  metrics: [],
}

const wifiHotspotTypes = {
  color: "#FF006E",
  icon: "im im-icon-Wifi",
  id: "4",
  isActive: false,
  name: "Wifi Hotspots",
  tooltip: "Δείτε απευθείας τα σημεία wifi hotspot της περιοχής",
  url: "",
}

const parkingDataTypes = {
  color: "#46eb54",
  icon: "",
  id: "36",
  isActive: false,
  name: "ΔΗΜΟΤΙΚΑ Parking",
  tooltip: "Δείτε τις θέσεις parking του Δήμου Ζακύνθου",
  url: "",
}

const getParkingData = () => {
  const parkingData = PARKING_DATA.features.map((data, index) => ({
    id: data.id,
    title: 'ΔΗΜΟΤΙΚΟ PARKING ' + (index + 1),
    position: {lat: data.geometry.coordinates[1], lng: data.geometry.coordinates[0]},
    address: null,
    boxTitle: "ΔΗΜΟΤΙΚΑ PARKING",
    color: "#46eb54",
    description: null,
    group: undefined,
    groupName: undefined,
    isActive: false,
    locationId: null,
    smallMarker: "https://zakynthos.smartiscity.gr/gallery/mapicons/pin-orange.png",
    tooltip: "Δείτε τις θέσεις δημοτικών parking",
    typeId: "36",
    metrics: [],
  }))

  return parkingData
}

const DynamicData = () => {
  const dispatch = useStore(false)[1];

  const controller = new AbortController();
  const { signal } = controller;

  const languageCtx = useContext(LanguageContext);

  useEffect(() => {
    const parkingData = getParkingData()

    const initialState = {
      sensors: [wifiHotspotSensors, ...parkingData], 
      types: [wifiHotspotTypes, parkingDataTypes]
    }

        console.log("PARKING", initialState)


    const feed_types_call = async () => {
      const data = await getAllTypes(
        `${allTypesUrl}&lang=${languageCtx.languageCode}`,
        signal
      );
      dispatch("INITIALIZE_TYPES", [...initialState.types, ...data]);
    };
    const feed_sensors = async () => {
      const data = await getAllSensors(
        `${allSensorsUrl}&lang=${languageCtx.languageCode}`,
        signal
      );
      dispatch("INITIALIZE_SENSORS", [...initialState.sensors, ...data]);
      getMetrics().catch((error) => console.warn(error));
    };

    feed_types_call().catch((error) => console.warn(error));
    feed_sensors().catch((error) => console.warn(error));
    return () => controller.abort();
  }, [languageCtx.languageCode]);

  const getMetrics = async () => {
    feedEnvironment_Meteo(`${enviURL}&lang=${languageCtx.languageCode}`, signal)
      .then((data) => dispatch("ADD_METRICS", data))
      .catch((error) => console.warn(error));

    // feedMeshlium(`${meshURL}&lang=${languageCtx.languageCode}`, signal)
    //   .then((data) => dispatch("ADD_METRICS", data))
    //   .catch((error) => console.warn(error));

    feedEnvironment_Meteo(
      `${meteoURL}&lang=${languageCtx.languageCode}`,
      signal
    )
      .then((data) => dispatch("ADD_METRICS", data))
      .catch((error) => console.warn(error));

    // feedPOIS(`${poiURL}&lang=${languageCtx.languageCode}`, signal)
    //   .then((data) => dispatch("ADD_SENSORS", data))
    //   .catch((error) => console.warn(error));

    feedFleeto(`${fleetoUrl}&lang=${languageCtx.languageCode}`, signal)
      .then((data) => dispatch("ADD_SENSORS", data))
      .catch((error) => console.warn(error));

    feedBins(`${binsUrl}&lang=${languageCtx.languageCode}`, signal)
      .then((data) => dispatch("ADD_SENSORS", data))
      .catch((error) => console.warn(error));

    feedHydro(`${hydroUrl}&lang=${languageCtx.languageCode}`, signal)
      .then((data) => dispatch("ADD_SENSORS", data))
      .catch((error) => console.warn(error));

    // feedWifi(`${wifiUrl}&lang=${languageCtx.languageCode}`, signal)
    //   .then((data) => dispatch("ADD_METRICS", data))
    //   .catch((error) => console.warn(error));

    feedParking(`${parkingUrl}&lang=${languageCtx.languageCode}`, signal)
      .then((data) => dispatch("ADD_SENSORS", data))
      .catch((error) => console.warn(error));
  };

  return null;
};

export default DynamicData;
